import { render, staticRenderFns } from "./StepperManyContacts.vue?vue&type=template&id=641957c2"
import script from "./StepperManyContacts.vue?vue&type=script&lang=js"
export * from "./StepperManyContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports